import { render } from "./AutomationTemplateCard.vue?vue&type=template&id=ae97a744&scoped=true"
import script from "./AutomationTemplateCard.vue?vue&type=script&lang=js"
export * from "./AutomationTemplateCard.vue?vue&type=script&lang=js"

import "./AutomationTemplateCard.vue?vue&type=style&index=0&id=ae97a744&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae97a744"]])

export default __exports__